export default class Lights {
  static on() {
    let $lights = $('.lights');
    $lights.removeClass('lights--animate');

    setTimeout(() => {
      $lights.remove();
    }, 300);
  }

  static off() {
    let node = $('<div class="lights"></div>');

    node.click(() => {
      this.close();
    });

    $('body').append(node);
    setTimeout(function(){
      node.addClass('lights--animate');
    }, 1);
  }
}
